module.exports = __webpack_public_path__ + "static/media/v2.0743c060.png";